import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { IDataDocumento, IRespTipoDocumento } from "../interfaces/tipo-documento.interface";
import { AuthenticationService } from "../../pages/services/authentication.service";
import { environment } from '@environments/environment';
import { IndexdbService } from '../../core/database/indexdb.service';

@Injectable({
  providedIn: 'root'
})
export class ObtenerTipoDocumentoService {
  private readonly indexDbService: IndexdbService = inject(IndexdbService);

  getTipoDocumento(): Observable<IDataDocumento[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.tiposDocumentos ?? [])
    );
  }
}
